
/**
* @author vishwadeep.kapoor
* HeaderContainer constants
*
*/
import { constants } from '../../devUtils';
import GiftCardIcon from '../../assets/images/gift-card-icon.png';
import redeemIcon from '../../assets/images/redeem-zaggle.png';
import ManageZaggle from '../../assets/images/manage-zaggle.png';
import MyAccount from '../../assets/images/my-account.png';
import CorporateIcon from '../../assets/images/corporate_mobile_icon.png';
import endPoints from '../../config/endPoints';
import { name } from 'file-loader';

export const DEFAULT_ERROR = '/ROOT/DEFAULT_ERROR';
export const DEFAULT_ERROR_CLEAR = '/ROOT/DEFAULT_ERROR_CLEAR';
export const DEFAULT_ACTION = '/HeaderContainer/DEFAULT_ACTION';
export const FETCH_USER_PROFILE_SUCCESS = '/HeaderContainer/FETCH_USER_PROFILE_SUCCESS';
export const SET_USER_PROFILE_LOGOUT = '/HeaderContainer/SET_USER_PROFILE_LOGOUT';
export const SET_USER_CITY = '/HeaderContainer/SET_USER_CITY';
export const SET_SEARCH_TYPE = '/HeaderContainer/SET_SEARCH_TYPE';
export const SET_WINDOW_SCREENCHANGE = '/HeaderContainer/SET_WINDOW_SCREENCHANGE';
export const SET_EVOUCHER_OTP = '/HeaderContainer/SET_EVOUCHER_OTP';

/**
 * @static
 */
export const MOBILE_BREAKPOINT = 760;
export const LINK_ANDROID_APP = 'https://play.google.com/store/apps/details?id=com.zaggle&hl=en';
export const LINK_IOS_APP = 'https://itunes.apple.com/in/app/zaggle-restaurant-cashbacks/id1030365320?mt=8';
export const TEXT_SEARCH_PLACEHOLDER = 'Search';
export const DEFAULT_CITY = { id: 0, city: 'Hyderabad', cityName: 'Hyderabad', location: { latitude: 17.4122998, longitude: 78.2679572 } };
export const TEXT_SEARCH_TYPES = [{ value: 'giftCards', label: 'Gift Cards' }];
/**
 * @constant @default in this file
 * @function @extends @property of header config
 * <*************start***************>
 */
const initialHeaderUi = {
  showSearch: true,
  showRestroDealLinks: true,
  showGiftCardLinks: true,
  primaryHeaderTitle: '',
  showTopHeaderLinks: true,
  showTopHeaderCardLinks: true,
  isCartShow: true, // specific to mobile rendering
  isMenuIconShow: true,
  isRedTapeShow: true,
  isShowCardHeader: true,
  isShowEdgeHeader: false,
  isShowLogin: true,
  isFlexiBenifitHeader: false,
  isPayrollCardHeader: false,
  isManipalHeader: true,
};
const SECONDRARY_HEADER = {
  PROPEL: {
    selectedOption: 'propel',
    isSecondryHeader: true,
    logo: endPoints.PROPEL_LOGO,
    params: {
      Overview: constants.LINK_PROPEL_OVERVIEW,
      Solutions: constants.LINK_PROPEL_SOLUTIONS,
      Pricing: constants.LINK_PROPEL_PRICING,
      Support: constants.LINK_PROPEL_SUPPORT,
    },
    buttontext: 'Signup',
    buttonlink: constants.LINK_PROPEL_SIGNUP,
  },
  EDGE: {
    selectedOption: 'edge',
    isSecondryHeader: false,
    logo: endPoints.EDGE_LOGO,
    params: {
      Overview: '/',
      Solutions: '/',
      Pricing: '/',
      Support: '/',
    },
    buttontext: '',
    buttonlink: '',
  },
  SAVE: {
    selectedOption: 'save',
    isSecondryHeader: true,
    logo: endPoints.SAVE_LOGO,
    params: {
      Overview: constants.LINK_SAVE,
      About: constants.LINK_ABOUT_US,
      'Contact Us': constants.LINK_CONTACTUS,
    },
    buttontext: 'Sign up',
    buttonlink: constants.LINK_SAVE_SIGNUP,
  },
  SELECT: {
    selectedOption: 'select',
    isSecondryHeader: false,
    logo: endPoints.SELECT_LOGO,
    params: {
      Overview: '/',
      Solutions: '/',
      Pricing: '/',
      Support: '/',
    },
    buttontext: '',
    buttonlink: '',
  },
};

const HEADER_CONFIG_THREE = {
  showTopHeaderLinks: false,
  isMenuIconShow: false,
  isRedTapeShow: false,
};

export const getHeaderConfigUi = (location) => {
  const thisConfig = switchPathConfig(location);
  return { ...initialHeaderUi, ...thisConfig };
};
const getHeaderDefaultSearchValue = (location, preSearchKey, userSeletedKey) => {
  const key = switchFilterConfig(location, preSearchKey, userSeletedKey);
  return key;
};
export const validateRootPath = (location, validPath) => ((location.indexOf(validPath) === 0) && location);

/**
 * @description removed Header to as similar to @default @constant only
 * @function switchPathConfig
 */
const switchPathConfig = ({ pathname }) => {
  switch (pathname) {
    case constants.LINK_HOME:
    case constants.LINK_PRESS:
    case constants.LINK_ABOUT_US:
    case constants.LINK_TEAM:
    case constants.LINK_CAREERS:
    case constants.LINK_CONTACTUS:
    case constants.LINK_ANNUAL_GENERAL_MEETING:
    case constants.LINK_MCMD:
    case constants.LINK_ZAGGLE_OVERVIEW:
    case constants.LINK_DISCLOSURES_REGULATION:
    case constants.ANNUAL_REPORTS_IPO:
    case constants.AUDIT_COMMITTEE:
    case constants.FINANCIALS:
    case constants.DISCLOSURE_EVENTS_INFORMATION:
    case constants.FINANCIAL_RESULTS_PUBLISHED_NEWSPAPER:
    case constants.DISCLOSURES_REGULATION_GENERAL_MEETINGS:
    case validateRootPath(pathname, '/board-of-directors'): // constants.BOARD_OF_DIRECTORS
    case validateRootPath(pathname, '/solutions'): // constants.LINK_SOLUTIONS
      return { isShowCardHeader: false };
    case validateRootPath(pathname, constants.LINK_EDGE_LANDING): // constants.LINK_EDGE_LANDING
    case constants.LINK_EDGE_LANDING:
      return { isShowEdgeHeader: true };
    case constants.LINK_GIFTCARD_LANDING:
    case constants.LINK_GIFTCARD_LIST:
    case constants.GIFT_CARD_CART:
    case constants.LINK_DELHIVERY_ADDRESS:
    case constants.LINK_ORDER_SUMMARY:
    case constants.LINK_REDEEM_ZSC:
    case constants.LINK_ZAGGLE_CARD_DEAILS:
    case constants.YSC_BANK_LIMITS:
    case constants.NSDL_BANK_LIMITS:
    case constants.NSDL_REQUEST_STATEMENT:
    case constants.YES_BANK_LIMITS:
    case constants.YES_REQUEST_STATEMENT:
    case constants.YBL_MIN_KYC:
    case constants.YBL_EXISTING_USERS:
    case constants.INDUSIND_MIN_KYC:
    case constants.YES_BANK_CARD_RENEWAL_MANAGEMENT:
    case constants.YES_BANK_REPLACE_CARD_PATH:
    case constants.YSC_WALLET_LOCK_UNLOCK:
    case constants.INDUSIND_BANK_ZINGER_CARDS_FAQS:
    case constants.INDUSIND_BANK_KUBER_CARDS_FAQS:
    case constants.YES_BANK_FAQS:
    case validateRootPath(pathname, constants.LINK_GIFTCARD_DETAILS):
      return HEADER_CONFIG_THREE;
    case constants.LINK_PROPEL:
      return SECONDRARY_HEADER.PROPEL;
    case constants.LINK_EDGE:
      return SECONDRARY_HEADER.EDGE;
    case constants.LINK_SAVE:
      return SECONDRARY_HEADER.SAVE;
    case constants.LINK_SELECT:
      return SECONDRARY_HEADER.SELECT;
    case constants.LINK_EMPLOYEE_FLEXI_BENEFITS:
      return { isShowCardHeader: false, isShowLogin: true, isFlexiBenifitHeader: true };
    case constants.LINK_PAYROLL_CARD:
      return { isShowCardHeader: false, isShowLogin: true, isPayrollCardHeader: true };
    case constants.LINK_PAYROLL_CARD_CONTACT:
      return { isShowCardHeader: false, isShowLogin: true, isPayrollCardHeader: true };
    case constants.LINK_MANIPAL_ABOUTUS:
    case constants.LINK_MANIPAL_REFUN_RETURN_POLICY:
    case constants.LINK_CLIENT_MANIPAL:
      return { isShowCardHeader: false, isShowLogin: false, isManipalHeader: false };
    case constants.LINK_PROPEL_CORPORATE_GIFITING_HOME:
      return { isShowCardHeader: false, isShowLogin: false, isManipalHeader: false };
    default:
      return {};
  }
};

const switchFilterConfig = ({ pathname }, preSearckKey, userSeletedKey) => {
  switch (pathname) {
    case constants.LINK_SEARCH_RESULT:
      return userSeletedKey || preSearckKey || 'giftCards';

    // case constants.LINK_RESTAURANTS:
    case constants.LINK_RESTAURANTS_DEALS:
    case validateRootPath(pathname, constants.LINK_RESTAURANTS):
    case validateRootPath(pathname, constants.LINK_RESTAURANTS_DETAILS):
      return userSeletedKey || 'giftCards';

    case constants.LINK_GIFTCARD_LANDING:
    case validateRootPath(pathname, constants.LINK_GIFTCARD_LIST):
    case constants.GIFT_CARD_CART:
    case constants.LINK_DELHIVERY_ADDRESS:
    case constants.LINK_ORDER_SUMMARY:
    case constants.LINK_REDEEM_ZSC:
    case validateRootPath(pathname, constants.LINK_ZAGGLE_CARD_DEAILS):
    case validateRootPath(pathname, constants.YSC_BANK_LIMITS):
    case validateRootPath(pathname, constants.YES_BANK_LIMITS):
    case validateRootPath(pathname, constants.YBL_MIN_KYC):
    case constants.LINK_PAY_BALANCE:
    case validateRootPath(pathname, constants.LINK_GIFTCARD_DETAILS):
    case validateRootPath(pathname, constants.NSDL_BANK_LIMITS):
    case validateRootPath(pathname, constants.YES_REQUEST_STATEMENT):
    case validateRootPath(pathname, constants.NSDL_REQUEST_STATEMENT):
    case validateRootPath(pathname, constants.YBL_EXISTING_USERS):
    case validateRootPath(pathname, constants.INDUSIND_MIN_KYC):
    case validateRootPath(pathname, constants.YES_BANK_CARD_RENEWAL_MANAGEMENT):
    case validateRootPath(pathname, constants.YES_BANK_REPLACE_CARD_PATH):
    case validateRootPath(pathname, constants.YSC_WALLET_LOCK_UNLOCK):
    case validateRootPath(pathname, constants.INDUSIND_BANK_ZINGER_CARDS_FAQS):
    case validateRootPath(pathname, constants.INDUSIND_BANK_KUBER_CARDS_FAQS):
    case validateRootPath(pathname, constants.YES_BANK_FAQS):
      return userSeletedKey || 'giftCards';
    case constants.LINK_CONFIRM: /** @todo create the post validating Script @example {validateRootPath} */
    case constants.LINK_MY_PROFILE:
    case constants.LINK_MY_ORDERS:
    case constants.LINK_MY_BOOKINGS:
      return userSeletedKey || 'giftCards';

    default:
      return userSeletedKey || 'giftCards';
  }
};


export const GET_DYNAMIC_LOGIN_CLASS = (isLoginSuccess, loggedIn) => {
  if (isLoginSuccess && loggedIn) {
    return 'log-in';
  } else if (isLoginSuccess && !loggedIn) {
    return 'log-in disable';
  }
  return 'log-in';
};
/**
 * <**********************end*****************************>
 */
export const CITIES = [ /** @const CITIES location if google fails to send response */
  {
    id: 1,
    city: 'Bangalore',
    cityName: 'Bangalore',
    location: { latitude: 12.9538477, longitude: 77.3507357 },
  },
  {
    id: 4,
    city: 'New Delhi',
    cityName: 'Delhi',
    location: { latitude: 28.5272178, longitude: 77.0685558 },
  },
  {
    id: 0,
    city: 'Hyderabad',
    cityName: 'Hyderabad',
    location: { latitude: 17.4122998, longitude: 78.2679572 },
  },
  {
    id: 3,
    city: 'Mumbai',
    cityName: 'Mumbai',
    location: { latitude: 19.0827699, longitude: 72.7411159 },
  },
  {
    id: 2,
    city: 'Pune',
    cityName: 'Pune',
    location: { latitude: 18.5245649, longitude: 73.7228791 },
  },
];

const MOBILE_MENU_CONFIG = [
  {
    link: constants.LINK_GIFTCARD_LANDING,
    linkClass: 'border',
    image: GiftCardIcon,
    name: 'Gift Card Deals',
    isAuthRequire: false,
  },
  {
    link: constants.LINK_REDEEM_ZSC,
    linkClass: '',
    image: redeemIcon,
    name: 'Redeem Zaggle Propel Card',
    isAuthRequire: false,
  },
  {
    link: '#/',
    linkClass: '',
    image: ManageZaggle,
    name: 'Cards & Payments',
    isAuthRequire: false,
    submenu: true,
    submenu_list: [
      {
        link: constants.LINK_MANAGE_ZAGGLE_CARD,
        name: 'Prepaid Cards',
        target: '',
      },
      {
        link: constants.LINK_ZAGGLE_CREDIT_CARDS,
        name: 'Credit Cards',
        target: '_blank',
      },
      {
        link: constants.ZAGGLE_CLOSED_LOOP_CARDS,
        name: 'Closed Loop Cards',
        target: '_blank',
      },
      {
        link: constants.LINK_FOREX_SERVICES,
        name: 'Forex Services',
        target: '_blank',
      },
    ],
  },
  {
    link: constants.LINK_MY_PROFILE,
    linkClass: '',
    image: MyAccount,
    name: 'My Account',
    isAuthRequire: true,
    submenu: true,
    submenu_list: [
      {
        link: constants.LINK_MY_BOOKINGS,
        name: 'My Bookings',
      },
      {
        link: constants.LINK_MY_ORDERS,
        name: 'My Orders',
      },
    ],
  },
  {
    link: '#/',
    linkClass: '',
    image: CorporateIcon,
    name: 'Products',
    isAuthRequire: false,
    submenu: true,
    submenu_list: [
      {
        link: '#/',
        name: 'Zoyer',
      },
      {
        link: constants.LINK_ZAGGLEZOYER,
        name: 'Procure-to-Pay',
        target: '_blank',
      },
      {
        link: constants.LINK_BROME,
        name: 'BROME',
        target: '_blank',
      },
      {
        link: '#/',
        name: 'SAVE',
      },
      {
        link: constants.LINK_SAVE,
        name: 'Employee Flexi Benefits',
        target: '_blank',
      },
      {
        link: constants.LINK_EMS,
        name: 'Employee Expenses',
        target: '_blank',
      },
      {
        link: constants.ZAGGLE_EMPLOYEE_PURCHASE_PROGRAM,
        name: 'Employee Purchase Program',
        target: '_blank',
      },
      {
        link: constants.LINK_PROPEL,
        name: 'Zaggle Propel',
        target: '_blank',
      },
      {
        link: constants.LINK_TAXSPANNER,
        name: 'Tax Solutions',
        target: '_blank',
      },
      {
        link: constants.ZAGGLE_CLOSED_LOOP_CARDS,
        name: 'Fleet Management',
        target: '_blank',
      },
      {
        link: constants.ZAGGLE_INTERNATIONAL_PAYMENTS,
        name: 'Zaggle International Payments',
        target: '_blank',
      },
    ],
  },
  {
    link: '#/',
    linkClass: '',
    image: CorporateIcon,
    name: 'Solutions',
    isAuthRequire: false,
    submenu: true,
    submenu_list: [
      {
        link: constants.NEXT_LINK_MID_SIZED_COMPANIES,
        name: 'Mid-Sized Companies',
        target: '_blank',
      },
      {
        link: constants.NEXT_LINK_SOLUTONS_CORPORATE,
        name: 'Enterprises',
        target: '_blank',
      },
    ],
  },
  {
    link: '#/',
    linkClass: '',
    image: CorporateIcon,
    name: 'Resources',
    isAuthRequire: false,
    submenu: true,
    submenu_list: [
      {
        link: constants.LINK_ZERO_TO_IPO,
        name: 'Zero to IPO series',
        target: '_blank',
      },
      {
        link: constants.LINK_BLOG,
        name: 'Blog',
        target: '_blank',
      },
    ],
  },
  {
    link: '#/',
    linkClass: '',
    image: CorporateIcon,
    name: 'Company',
    isAuthRequire: false,
    submenu: true,
    submenu_list: [
      {
        link: constants.NEXT_LINK_ABOUT_US,
        name: 'About Us',
        target: '_blank',
      },
      {
        link: constants.NEXT_LINK_TEAM,
        name: 'Team',
        target: '_blank',
      },
      {
        link: constants.NEXT_LINK_CAREERS,
        name: 'Careers',
        target: '_blank',
      },
      {
        link: constants.NEXT_LINK_PRESS,
        name: 'News',
        target: '_blank',
      },
      {
        link: constants.NEXT_LINK_CONTACT_US,
        name: 'Contact Us',
        target: '_blank',
      },
    ],
  },
];

export {
  getHeaderDefaultSearchValue,
  MOBILE_MENU_CONFIG,
};



// WEBPACK FOOTER //
// client/containers/HeaderContainer/constants.js